export const environment = {
  api: {
    url: 'https://dcarbonizer-back-dev.fromscratch-apis.com'
  },
  email: 'hi@fromscratch.gr',
  auth0: {
    domain: 'dcarbonizer.eu.auth0.com',
    clientId: 'lppvGJrKGNSMTutJiUC2XcgIXKWFUgcE',
    audience: 'https://dcarbonizer-dev-api.com'
  }
};
